import { defineMessages } from 'react-intl';

export default defineMessages({
    /**
     * Messages used in the *.metadata.json5
     */

    mandatoryValidation: {
        id: 'fnol.common.contract.sasria-property-incident.mandatoryValidationId',
        defaultMessage: 'Mandatory field validation failed'
    },
    haveLossEstimateMandatory: {
        id: 'fnol.common.contract.sasria-property-incident.haveLossEstimateMandatory',
        defaultMessage: 'Missing required field "Do you have a Loss Estimate?"'
    },
    lossEstimatateMandatory: {
        id: 'fnol.common.contract.sasria-property-incident.lossEstimatateMandatory',
        defaultMessage: 'Missing required field "Loss Estimate"'
    },
    incorrectLossEstimatateMessage: {
        id: 'fnol.common.contract.sasria-property-incident.incorrectLossEstimatateMessage.',
        defaultMessage: 'Loss Estimate is an Amount field and cannot accept alphanumeric values'
    },

    fnolLossEstimateErrorTitle: {
        id: 'fnol.common.contract.sasria-property-incident.Loss Estimate validation failed',
        defaultMessage: 'Loss Estimate validation failed'
    },

    fnolLossEstimateErrorMessage: {
        id: 'fnol.common.contract.sasria-property-incident.Value of Loss Estimate cannot be less than R1.0',
        defaultMessage: 'Value of Loss Estimate cannot be less than R1.0'
    },

    fnolLossEstimateErrorMessageLessThan16: {
        id: 'fnol.common.contract.sasria-property-incident.can have no more than 16 digit to left of decimal point',
        defaultMessage: 'can have no more than 16 digit to left of decimal point'
    },

    
  
});
